<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   transform="scale(1.1)"
   viewBox="0 0 24 24"
   version="1.1"
   id="svg2"
   sodipodi:docname="video-lang.svg"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25, custom)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview2"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="30.708333"
     inkscape:cx="12"
     inkscape:cy="12.016282"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg2" />
  <defs
     id="defs1" />
  <g
     class="layer"
     id="g2"
     transform="translate(1.1816062,0.78854308)">
    <path
       fill="transparent"
       fill-rule="evenodd"
       stroke="currentColor"
       stroke-width="1.8"
       d="m 20.5,6.7 c 0,0 -0.2,-1.4 -0.8,-2 C 19,3.9 18.1,3.9 17.7,3.8 15,3.6 10.8,3.6 10.8,3.6 v 0 c 0,0 -4.2,0 -7,0.2 -0.3,0 -1.2,0 -2,0.9 -0.5,0.6 -0.7,2 -0.7,2 L 0.9,10 v 1.6 l 0.2,3.3 c 0,0 0.2,1.4 0.8,2 0.7,0.8 1.7,0.8 2.2,0.9 1.6,0.2 6.7,0.2 6.7,0.2 0,0 4.2,0 7,-0.2 0.3,0 1.2,0 2,-0.9 0.5,-0.6 0.7,-2 0.7,-2 l 0.2,-3.3 V 10 Z"
       id="path1" />
    <path
       d="M 8.7,14.7 A 0.7,0.7 0 0 1 8.2,13.5 l 2.9,-3 H 8.7 a 0.7,0.7 0 0 1 0,-1.3 h 4 a 0.7,0.7 0 0 1 0.5,1.2 l -4,4 a 0.7,0.7 0 0 1 -0.5,0.3 z m 3,-6.1 h -2 a 0.7,0.7 0 1 1 0,-1.4 h 2 a 0.7,0.7 0 0 1 0,1.4 z"
       id="path2" />
  </g>
</svg>
